import React from "react";

function ImpressumSide() {
  return (
    <section className="max-w-3xl mx-auto px-4 py-12 text-center font-sans text-slate-800">
      <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Impressum nach &sect; 5 TMG</h1>

      <div className="mb-12">
        <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8 border-b pb-2 inline-block">Betreiber und Administrator</h2>
        <p className="text-lg leading-relaxed text-slate-700 mt-4">
          <b>Simon Altsch&auml;ffl</b> <br />
          Sammern 6b <br />
          94554 Moos
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b pb-2 inline-block">Kontakt</h2>
        <p className="text-lg leading-relaxed text-slate-700 mt-4">
          <b className="font-semibold">Telefon:&nbsp;</b>
          <a href="tel:+4915157852478" className="text-blue-600 hover:underline hover:text-blue-800 transition-colors">+49 1515 7852478</a>
          <br />
          <b className="font-semibold">Email:</b>
          <a href="mailto:info@simonaltschaeffl.de" className="text-blue-600 hover:underline hover:text-blue-800 transition-colors">info@simonaltschaeffl.de</a>
        </p>
      </div>
    </section>
  );
}

export default ImpressumSide;